const MouseIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 29.3334C21.5067 29.3334 26 24.8401 26 19.3334V12.6667C26 7.16008 21.5067 2.66675 16 2.66675C10.4933 2.66675 6 7.16008 6 12.6667V19.3334C6 24.8401 10.4933 29.3334 16 29.3334Z"
      stroke="#51B94F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 14.6667C14.8933 14.6667 14 13.7733 14 12.6667V10C14 8.89333 14.8933 8 16 8C17.0933 8 18 8.89333 18 10V12.6667C18 13.7733 17.0933 14.6667 16 14.6667Z"
      stroke="#51B94F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 8.00008V2.66675"
      stroke="#51B94F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default MouseIcon;
